import { BaseIcon } from "@shltelemedicine/shl-ui-lib";
import studyIcon from "../../../assets/management/study.svg";
import styles from "./StudyIcon.module.css";
import { PropsWithClassName } from "../../../models/props-with-class-name";

const StudyIcon = ({
  size,
  className,
}: PropsWithClassName<{ size?: "sm" | "lg" }>) => (
  <BaseIcon
    icon={studyIcon}
    className={`${styles.icon} ${size && styles[size]} ${className}`}
  />
);

export default StudyIcon;
